import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export function FormSection() {
  return <section id="formulario" className="py-24 px-6 bg-soft-gradient scroll-mt-20" data-id="element-151">
      <div className="max-w-[860px] mx-auto flex flex-col items-center" data-id="element-152">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-4 text-center" data-id="element-153">
          Es Tu Momento
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-playfair font-bold text-deep-blue text-3xl md:text-[42px] leading-[1.2] text-center mb-4" data-id="element-154">
          Comparte Tu Historia
          <br data-id="element-155" />
          y Cambia la Vida
          <br data-id="element-156" />
          de Otra Mujer
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="font-montserrat text-gray-text text-center mb-12" data-id="element-157">
          Toma menos de 10 minutos. Vale para siempre.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="w-full bg-white rounded-3xl shadow-luxury-card border-t-[6px] border-t-champagne-gold p-6 md:p-12 mb-12" data-id="element-158">
          <div className="flex items-center gap-4 mb-6" data-id="element-159">
            <Logo className="w-10 h-10" data-id="element-160" />
            <span className="font-playfair font-semibold text-deep-blue text-lg" data-id="element-161">
              RenuevaTE_90 | Lorena Pérez
            </span>
          </div>
          <div className="w-full h-[1px] bg-champagne-gold/30 mb-8" data-id="element-162"></div>

          {/* JOTFORM EMBED */}
          <div className="w-full rounded-xl overflow-hidden" data-id="element-163">
            <iframe title="Comparte Tu Historia — RenuevaTE_90" src="https://form.jotform.com/261348347824059" className="w-full border-0" style={{
            minHeight: '900px'
          }} allow="geolocation; microphone; camera; fullscreen" allowFullScreen scrolling="auto" data-id="element-164" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-[800px]" data-id="element-165">
          <div className="flex flex-col items-center text-center" data-id="element-166">
            <span className="text-3xl mb-3" data-id="element-167">🔒</span>
            <h4 className="font-montserrat font-semibold text-deep-blue text-sm mb-1" data-id="element-168">
              Tu información es privada
            </h4>
            <p className="font-montserrat text-gray-text text-xs" data-id="element-169">
              Nunca la compartimos
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-170">
            <span className="text-3xl mb-3" data-id="element-171">💙</span>
            <h4 className="font-montserrat font-semibold text-deep-blue text-sm mb-1" data-id="element-172">
              Tú tienes el control
            </h4>
            <p className="font-montserrat text-gray-text text-xs" data-id="element-173">
              Decides qué se publica
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-174">
            <span className="text-3xl mb-3" data-id="element-175">✍️</span>
            <h4 className="font-montserrat font-semibold text-deep-blue text-sm mb-1" data-id="element-176">
              Revocable siempre
            </h4>
            <p className="font-montserrat text-gray-text text-xs" data-id="element-177">
              Retiras en 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}